import React from 'react';
import '../styles/footer.css';
import ig from '../assets/ig.png';
import x from '../assets/x.png';
import linkedin from '../assets/linkdin.png';

function Footer() {
  return (
    <footer className="bg-footer py-8 px-4 md:px-16">
      {/* Contact and Socials */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Contact */}
        <div className="text-center md:text-left">
          <h2 className="text-[1rem] font-semibold mb-2">Contact us</h2>
          <p className="text-footertext text-[0.9rem]">+1 (405) *** ****</p>
          <p className="text-footertext text-[0.9rem]">+1 (405) *** ****</p>
        </div>

        {/* Socials */}
        <div className="text-center md:text-right">
          <h2 className="text-[1rem] font-semibold mb-2">Follow us</h2>
          <div className="flex flex-row justify-center md:justify-end gap-4">
            <a href="#1">
              <img src={ig} alt="Instagram" className="w-6 h-6" />
            </a>
            <a href="#1">
              <img src={x} alt="X" className="w-6 h-6" />
            </a>
            <a href="#1">
              <img src={linkedin} alt="LinkedIn" className="w-6 h-6" />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="mt-8 text-center text-footertext text-sm">
        © 2025 Shophub. All rights reserved
      </div>
    </footer>
  );
}

export default Footer;
